(function () {
  const HTML = document.documentElement;
  const CART_PATH = "/cart";
  const TYPE_NG_VALUE = "null";
  const VALIDATE_DEBOUNCE_MS = 50;
  const POLL_INTERVAL_MS = 1500;
  const SAVED_KEY = 'shopify_cart_saved_items';

  let timerId = null;

  // ===== 商品タイプの収集（チェック済のみ） =====
  const normalizeType = (value) => String(value || "").replace(/\s+/g, " ").trim();

  const collectUniqueTypes = () => {
    const root = getActiveRoot();
    const allItemNodes = Array.from(root.querySelectorAll("[data-aw-cart-item][data-aw-product-type], .cart-item[data-aw-product-type]"));
    
    const selectedNodes = allItemNodes.filter((el) => {
      const checkbox = el.querySelector('.cart-item__check');
      return checkbox ? checkbox.checked : true;
    });

    const types = selectedNodes
      .map((el) => normalizeType(el.dataset.awProductType))
      .filter((v) => v && v !== TYPE_NG_VALUE);

    return Array.from(new Set(types));
  };

  const getActiveRoot = () => {
    if (location.pathname === CART_PATH) return document.querySelector("main") || document;
    const openedDrawer = document.querySelector("#CartDrawer:not([hidden])");
    return openedDrawer || document;
  };

  const hasCartContext = () => {
    if (location.pathname === CART_PATH) return true;
    return Boolean(document.querySelector(".cart-drawer, #CartDrawer"));
  };

  // ===== UI反映 =====
  const applyState = ({ canCheckout, uniqueTypes }) => {
    HTML.classList.toggle("aw-cart-type-ok", canCheckout);
    HTML.classList.toggle("aw-cart-type-ng", !canCheckout);

    const LABEL_MAP = { "国際配送": "国際配送商品" };
    const displayTypes = uniqueTypes.map((t) => LABEL_MAP[t] ?? t);
    const prefix = displayTypes.length ? displayTypes.join("・") : "";
    const msg = canCheckout ? "" : `${prefix}は同時に購入できません。購入する商品のみ選択してください。`;

    const page = document.getElementById("cartpage-error-message");
    const drawer = document.getElementById("drawercart-error-message");

    [page, drawer].filter(Boolean).forEach((el) => {
      el.textContent = msg;
      el.toggleAttribute("hidden", canCheckout);
    });
  };

  const validate = () => {
    if (!hasCartContext()) return;
    const uniqueTypes = collectUniqueTypes();
    const canCheckout = uniqueTypes.length <= 1;
    applyState({ canCheckout, uniqueTypes });
    window.__awCartTypeGuard = { uniqueTypes, canCheckout };
  };

  const scheduleValidate = () => {
    clearTimeout(timerId);
    timerId = setTimeout(validate, VALIDATE_DEBOUNCE_MS);
  };

  // ===== 1. カートに戻す処理 (バーが伸びるのを確実にする修正版) =====
  async function restoreItems() {
    const savedData = localStorage.getItem(SAVED_KEY);
    if (!savedData) return;

    // 即座にメモリから削除（これが遅れると二重実行の原因になります）
    localStorage.removeItem(SAVED_KEY);

    let itemsToRestore = [];
    try {
      itemsToRestore = JSON.parse(savedData);
    } catch (e) { return; }

    if (!itemsToRestore || itemsToRestore.length === 0) return;

    try {
      // 現在のカートをチェック
      const currentCart = await fetch('/cart.js').then(r => r.json());
      const finalItemsToAdd = itemsToRestore.filter(savedItem => {
        return !currentCart.items.some(cartItem => String(cartItem.variant_id) === String(savedItem.id));
      });

      // 追加すべきものがなければ終了
      if (finalItemsToAdd.length === 0) return;

      // --- ローディング表示（CSSアニメーションなので出すだけで動く） ---
      const loader = document.createElement('div');
      loader.className = 'aw-restore-loading';
      loader.innerHTML = '<div class="aw-progress-container"><div class="aw-progress-bar"></div></div>';
      document.body.appendChild(loader);

      // 追加処理
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          items: finalItemsToAdd.map(i => ({ id: i.id, quantity: parseInt(i.qty) })) 
        })
      });

      // 完了したら即リロード（余計なsetTimeoutは入れない）
      window.location.reload();

    } catch (e) {
      console.error('[aw-cart] Restore failed', e);
      const loader = document.querySelector('.aw-restore-loading');
      if(loader) loader.remove();
    }
  }

  // ===== 2. チェックアウト時の退避処理 =====
  async function handleCheckout(e) {
    const root = getActiveRoot();
    const unselectedCheckboxes = root.querySelectorAll('.cart-item__check:not(:checked)');
    
    // 送料無料バー 動的更新
function updateFreeShippingBar(totalPrice) {
  const thresholdEx = 8000;
  const priceExTax = Math.round(totalPrice / 100); // 税抜き変換不要
  const remaining = thresholdEx - priceExTax;
  const progress = Math.min(Math.round(priceExTax / thresholdEx * 100), 100);

  const bar = document.getElementById('free-shipping-bar');
  if (!bar) return;

  const fill = bar.querySelector('.free-shipping-bar__fill');
  const msg = bar.querySelector('.free-shipping-bar__message');

  if (fill) fill.style.width = progress + '%';

  if (msg) {
    if (priceExTax >= thresholdEx) {
      msg.innerHTML = '送料無料！';
      msg.classList.add('free-shipping-bar__message--achieved');
    } else {
      const formatted = remaining.toLocaleString('ja-JP');
      msg.innerHTML = `あと <strong>${formatted}円（税抜）</strong> で送料無料`;
      msg.classList.remove('free-shipping-bar__message--achieved');
    }
  }
}

// カート変更を監視してバーを更新
document.addEventListener('change', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateFreeShippingBar(cart.total_price));
});

document.addEventListener('click', () => {
  setTimeout(() => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateFreeShippingBar(cart.total_price));
  }, 500);
});

    // 全て選択されている場合は保存データを消して通常チェックアウト
    if (unselectedCheckboxes.length === 0) {
      localStorage.removeItem(SAVED_KEY);
      return;
    }

    if (window.__awCartTypeGuard && !window.__awCartTypeGuard.canCheckout) {
      e.preventDefault();
      alert("同梱できない商品が選択されています。");
      return;
    }

    e.preventDefault();
    const checkoutBtn = e.currentTarget;
    checkoutBtn.disabled = true;
    checkoutBtn.innerText = '処理中...';

    // 以前の保存データは一度リセットし、今回の「未選択分」だけを新規保存
    const itemsToSave = [];
    const updates = {};
    unselectedCheckboxes.forEach(cb => {
      itemsToSave.push({ id: cb.dataset.variantId, qty: cb.dataset.quantity });
      updates[cb.dataset.variantId] = 0;
    });

    localStorage.setItem(SAVED_KEY, JSON.stringify(itemsToSave));

    try {
      // カートの更新（未選択商品の削除）
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      // 成功したらチェックアウト画面へ
      window.location.href = '/checkout';
    } catch (e) {
      console.error('[aw-cart] 退避処理に失敗', e);
      checkoutBtn.disabled = false;
      checkoutBtn.innerText = 'ご購入手続き';
    }
  }

  // ===== 初期化 =====
  const init = () => {
    // 復元処理を実行
    restoreItems();
    validate();

    document.addEventListener("change", (e) => {
      if (e.target.classList.contains('cart-item__check')) validate();
      if (e.target.closest('form[action="/cart"], cart-items, #CartDrawer')) scheduleValidate();
    });

    document.addEventListener("click", (e) => {
      const btn = e.target.closest('button[name="checkout"]');
      if (btn) {
        handleCheckout(e);
        return;
      }
      if (e.target.closest('form[action="/cart"], cart-items, #CartDrawer')) scheduleValidate();
    });

    const mo = new MutationObserver(scheduleValidate);
    [document.body, document.querySelector("#CartDrawer")].filter(Boolean).forEach(t => {
      mo.observe(t, { childList: true, subtree: true });
    });

    setInterval(validate, POLL_INTERVAL_MS);
  };

  init();
})();

/* ===== ORIGINAL SHOPPER GIFT BANNER ===== */
(function () {
  const GIFT_VARIANT_ID     = '44323463135283';
  const GIFT_PRODUCT_HANDLE = 'presingoriginalshopper';
  const EXCLUDED_TAG        = '配送指定不可';
  const THRESHOLD           = 3000;
  const CAMPAIGN_START      = new Date('2026-06-01T00:00:00+09:00');
  const CAMPAIGN_END        = new Date('2026-06-14T23:59:59+09:00');

  let isBannerUpdating = false;
  let pendingUpdate = false;

  function isWithinCampaignPeriod() {
    const now = new Date();
    return now >= CAMPAIGN_START && now <= CAMPAIGN_END;
  }

  async function isGiftInStock() {
    try {
      const res = await fetch('/products/' + GIFT_PRODUCT_HANDLE + '.js');
      const product = await res.json();
      return product.variants.some(function (v) {
        return String(v.id) === GIFT_VARIANT_ID && v.available;
      });
    } catch (e) {
      return false;
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function shouldShowGiftBanner() {
    if (!isWithinCampaignPeriod()) return false;
    if (!await isGiftInStock()) return false;
    if (window.noveltySoldOut === true) return false;

    const cart = await getCart();
    const eligibleItems = cart.items.filter(function (item) {
      return String(item.variant_id) !== GIFT_VARIANT_ID;
    });

    for (const item of eligibleItems) {
      try {
        const res = await fetch('/products/' + item.handle + '.js');
        if (!res.ok) continue; // ★404などのエラーはスキップ
        const product = await res.json();
        const tags = product.tags || [];
        if (tags.includes(EXCLUDED_TAG)) return false;
      } catch (e) {
        continue; // ★エラーはスキップ
      }
    }

    const subtotal = eligibleItems.reduce(function (sum, item) {
      return sum + (item.final_line_price / 100);
    }, 0);

    return subtotal >= THRESHOLD;
  }

  async function addGiftItem() {
    const cart = await getCart();
    const alreadyInCart = cart.items.some(function (item) {
      return String(item.variant_id) === GIFT_VARIANT_ID;
    });
    if (alreadyInCart) return;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
    });
  }

  async function removeGiftItem() {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 0 })
    });
  }

  function lockGiftItemUI() {
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    cartDrawer.querySelectorAll('.cart-item').forEach(function (cartItem) {
      const input = cartItem.querySelector('input[data-quantity-variant-id="' + GIFT_VARIANT_ID + '"]');
      if (!input) return;

      cartItem.querySelectorAll('.quantity__button').forEach(function (btn) {
        btn.classList.add('hidden');
        btn.disabled = true;
      });
      input.disabled = true;

      const imgLink = cartItem.querySelector('.cart-item__media');
      if (imgLink && imgLink.tagName === 'A') {
        imgLink.removeAttribute('href');
        imgLink.style.pointerEvents = 'none';
        imgLink.style.cursor = 'default';
      }

      const titleLink = cartItem.querySelector('.cart-item__title');
      if (titleLink && titleLink.tagName === 'A') {
        titleLink.removeAttribute('href');
        titleLink.style.pointerEvents = 'none';
        titleLink.style.cursor = 'default';
      }
    });
  }

  function scheduleUpdateGiftBanner() {
    if (isBannerUpdating) {
      pendingUpdate = true;
      return;
    }
    runUpdateGiftBanner();
  }

  async function runUpdateGiftBanner() {
    isBannerUpdating = true;
    try {
      const banner   = document.getElementById('gift-bag-banner');
      const checkbox = document.getElementById('gift-bag-checkbox');
      if (!banner || !checkbox) return;

      const show = await shouldShowGiftBanner();

      if (show) {
        banner.style.display = 'block';
      } else {
        banner.style.display = 'none';
        if (checkbox.checked) {
          checkbox.checked = false;
          observer.disconnect();
          await removeGiftItem();
          startObserver();
        }
      }
    } finally {
      isBannerUpdating = false;
      lockGiftItemUI();
      if (pendingUpdate) {
        pendingUpdate = false;
        setTimeout(runUpdateGiftBanner, 300);
      }
    }
  }

  document.addEventListener('change', async function (e) {
    if (e.target.id !== 'gift-bag-checkbox') return;
    observer.disconnect();
    if (e.target.checked) {
      await addGiftItem();
    } else {
      await removeGiftItem();
    }
    startObserver();
    await runUpdateGiftBanner();
  });

  const observer = new MutationObserver(function () {
    scheduleUpdateGiftBanner();
    lockGiftItemUI();
  });

  function startObserver() {
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    runUpdateGiftBanner();
    startObserver();
  });

})();


/* ===== /ORIGINAL SHOPPER GIFT BANNER ===== */
/* ===== DELIVERY CONTROL ===== */
(function () {
  let restoreTimer = null;
  let hideTimer = null;
  let cachedIsControlled = false;

  function hideEl() {
    document.querySelectorAll('#cc-calendar-overall, #cc-calendar-input-overall').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function startHideLoop() {
    hideEl();
    if (hideTimer) return;
    hideTimer = setInterval(hideEl, 50);
  }

  function stopHideLoop() {
    if (hideTimer) {
      clearInterval(hideTimer);
      hideTimer = null;
    }
  }

  function getVariantMap() {
    const el = document.querySelector('[data-payment-control-variants]');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }

  // カートの実際のアイテムと_controlled_idsを照合して同期
  function syncControlledState() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const cartVariantIds = (cart.items || []).map(function (i) { return String(i.variant_id); });

        // 既存の_controlled_idsを取得
        let controlledIds = [];
        try {
          controlledIds = JSON.parse(cart.attributes['_controlled_ids'] || '[]');
        } catch (e) { controlledIds = []; }

        // カートに残っているアイテムのみに絞る
        const activeControlledIds = controlledIds.filter(function (id) {
          return cartVariantIds.includes(String(id));
        });

        // ページ上の[data-payment-control-variants]からも追加
        const map = getVariantMap();
        cartVariantIds.forEach(function (id) {
          if (map[id] === true && !activeControlledIds.includes(id)) {
            activeControlledIds.push(id);
          }
        });

        const hasControlled = activeControlledIds.length > 0;
        cachedIsControlled = hasControlled;

        // カート属性を更新
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              '_controlled_ids': JSON.stringify(activeControlledIds),
              '_delivery_control': hasControlled ? 'true' : '',
              '_payment_control': hasControlled ? 'true' : ''
            }
          })
        }).then(function () { return hasControlled; });
      });
  }

  function applyDeliveryControl() {
    syncControlledState().then(function (hasControlled) {
      if (hasControlled) {
        startHideLoop();
      } else {
        stopHideLoop();
      }
    });
  }

  // fetchインターセプト（cart/add のみ）
  const _origFetch = window.fetch.bind(window);
  window.fetch = function (url, opts) {
    const urlStr = typeof url === 'string' ? url : (url?.url || '');

    if (urlStr.includes('/cart/add') && opts && opts.body) {
      try {
        const body = JSON.parse(opts.body);
        const variantId = String(body.id || (body.items && body.items[0] && body.items[0].id) || '');
        if (variantId) {
          const map = getVariantMap();
          const isControlled = map[variantId] === true;

          if (isControlled) {
            // 既存の_controlled_idsにこのIDを追加
            _origFetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                let controlledIds = [];
                try {
                  controlledIds = JSON.parse(cart.attributes['_controlled_ids'] || '[]');
                } catch (e) { controlledIds = []; }
                if (!controlledIds.includes(variantId)) {
                  controlledIds.push(variantId);
                }
                cachedIsControlled = true;
                return _origFetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    attributes: {
                      '_controlled_ids': JSON.stringify(controlledIds),
                      '_delivery_control': 'true',
                      '_payment_control': 'true'
                    }
                  })
                });
              });
          }
        }
      } catch (e) {}
    }

    return _origFetch(url, opts);
  };

  function watchCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'active') {
          if (drawer.hasAttribute('active')) {
            if (cachedIsControlled) startHideLoop();
            applyDeliveryControl();
          } else {
            stopHideLoop();
          }
        }
      });
    }).observe(drawer, { attributes: true });
  }

  function init() {
    applyDeliveryControl();
    FoxTheme.pubsub.subscribe('cart-update', function () {
      if (restoreTimer) clearTimeout(restoreTimer);
      restoreTimer = setTimeout(applyDeliveryControl, 500);
    });
    watchCartDrawer();
  }

  if (window.FoxTheme?.pubsub) {
    init();
  } else {
    window.addEventListener('load', function () {
      if (window.FoxTheme?.pubsub) init();
    });
  }
})();
